export const courseFlow = {
  title: '코스 흐름',
  subtitle: 'EachTeach 학습 프로세스를 소개합니다',
  
  // Hero
  heroTitle: '코스 흐름',
  heroSubtitle: '기초가 되는 A~C 레벨 코스부터 실전 중심의 어드밴스 레슨까지',
  
  // Level Check Notice
  levelCheckTitle: '레벨 체크 테스트에 대하여',
  levelCheckDescription1: '모든 수강생은 레벨 체크 테스트를 받으셔야 합니다.',
  levelCheckDescription2: '테스트 결과를 바탕으로 현재 언어 레벨(A, B1, B2, C)을 판정하고, 최적의 레벨에서 시작할 수 있도록 지원합니다.',
  levelCheckDescription3: '초보자는 레벨 A부터, 이미 기초가 있는 분은 B1이나 B2부터 시작할 수 있어',
  levelCheckDescription4: '불필요한 시간을 들이지 않고 효율적으로 학습을 진행할 수 있습니다.',
  levelCheckButton: '레벨 체크 받기',
  registerButton: '먼저 등록하기',
  
  // Foundation Courses
  foundationTitle: '기초 코스 (A~C)',
  
  // Level A
  levelATitle: '완전 초보자',
  levelALessons: '18레슨 + A레벨 단어 노트',
  levelADescription: '완전 초보자용. 기본 어휘와 문법 기초를 배웁니다.',
  
  // Extra Lessons
  extraLessonAB1: '엑스트라 레슨 (A→B1)',
  extraLessonAB1Description: '1회 테스트 + 2회 보강 레슨 = 3레슨 요금',
  
  // Level B1
  levelB1Title: '중급 기초',
  levelB1Lessons: '14레슨',
  levelB1Description: '일상 회화의 유창함을 구축하고 어휘를 확장합니다.',
  
  extraLessonB1B2: '엑스트라 레슨 (B1→B2)',
  extraLessonB1B2Description: '1회 테스트 + 2회 보강 레슨 = 3레슨 요금',
  
  // Level B2
  levelB2Title: '프로페셔널 레벨',
  levelB2Lessons: '10레슨',
  levelB2Description: '접객 업무가 가능한 레벨. 뉘앙스와 관용구를 다듬습니다.',
  
  extraLessonB2C: '엑스트라 레슨 (B2→C)',
  extraLessonB2CDescription: '1회 테스트 + 2회 보강 레슨 = 3레슨 요금',
  
  // Level C
  levelCTitle: '원어민에 가까운 유창함',
  levelCLessons: '10레슨',
  levelCDescription: '원어민에 가까운 유창함. 문화적 뉘앙스와 고급 표현을 마스터합니다.',
  
  // Additional Lessons
  additionalTitle: '어드밴스 레슨',
  additionalBadge: 'A~C 레벨 수료 후',
  additionalSubtitle: '8개의 전문 분야별 코스.',
  additionalPricing: '요금은 일반 레슨의 1.2배입니다.',
  
  // Courses
  course1Title: '일상생활과 캐주얼 커뮤니케이션',
  course1Description: '일상 회화, 잡담, 슬랭, 관용구 등',
  
  course2Title: '접객·호스피탈리티 커뮤니케이션',
  course2Description: '주문 대응, 설명, 추천, 클레임 대응 등',
  
  course3Title: '주방·조리 커뮤니케이션',
  course3Description: '지시, 식재료·조리 용어, 안전 확인 등',
  
  course4Title: '판매·계산대 커뮤니케이션',
  course4Description: '상품 설명, 재고 확인, 결제, 반품·교환 등',
  
  course5Title: '호텔·프론트 업무',
  course5Description: '체크인·아웃, 시설 안내, 전화 대응 등',
  
  course6Title: '청소·백야드 업무',
  course6Description: '지시 이해, 확인 표현, 체크리스트, 안전 관련 등',
  
  course7Title: '리조트·계절 노동',
  course7Description: '관광지나 단기 고용에서의 다국적 환경 커뮤니케이션',
  
  course8Title: '직장·고급 커뮤니케이션',
  course8Description: '이메일, 보고, 조정, 의뢰, 트러블 공유 등',
  
  lessonsLabel: '레슨',
  registerNow: '지금 등록하기'
};
